import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BcmService } from '@modules/bcm/bcm.service';
import { BcmVoucher, BcmVoucherDto } from '@shared/models/bcm-voucher';
import { BcmBaseFacade } from '@modules/bcm/@core/state-management/bcm-base.facade';
import { BcmUserPermission } from '@modules/bcm/bcm-user-permission';
import { AppNotificationService } from '@core/services/app-notification.service';
import { ConfirmDialogService } from '@sharedComponents/dialogs/confirm-dialog/confirm-dialog.service';
import { BcmExportExcelApiService } from '@bcmApiServices/bcm-export-excel.api-service';
import { TranslationService } from '@core/translation/translation.service';
import { vouchersTableData } from '@modules/bcm/@core/state-management/vouchers/bcm-vouchers-table-data';
import { BcmUserSettingsFacade } from '@bcmServices/settings/bcm-user-settings-facade';
import { BcmTenantPermission } from '@modules/bcm/bcm-tenant-permission';
import { BcmNavigationService } from '@modules/bcm/bcm-navigation.service';
import { ThemePalette } from '@angular/material/core';

@Injectable({providedIn: 'root'})
export class BcmVouchersFacade extends BcmBaseFacade<BcmVoucher, BcmVoucherDto> {

    readonly resourcePath = 'vouchers';

    readonly resourceNameSingular = TranslationService.translate('voucher');

    readonly resourceNamePlural = TranslationService.translate('vouchers');

    readonly resourceIconPlural = 'redeem';

    readonly resourceIconSingular = 'redeem';

    readonly deletePermission = BcmUserPermission.PRODUCTS_DELETE;

    readonly readPermission = BcmUserPermission.PRODUCTS_READ;

    readonly writePermission = BcmUserPermission.PRODUCTS_WRITE;

    readonly headerActions = [
        {
            title: 'Excel Export',
            onClick: () => this._bcmExportExcelApiService.exportVouchers(),
            tenantPermissions: [BcmTenantPermission.REPORTS],
        }
    ];

    readonly rowActions = [
        {
            title: 'Datensatz anzeigen',
            icon: 'assignment',
            iconColor: 'accent' as ThemePalette,
            onClick: (voucher: BcmVoucher) => this.bcmNavigationService.navigate('vouchers/' + voucher.id),
        },
        {
            title: 'Datensatz löschen',
            icon: 'delete',
            iconColor: 'warn' as ThemePalette,
            onClick: (voucher: BcmVoucher) => super.remove(voucher, voucher.title).subscribe(),
        }
    ];

    constructor(appNotificationService: AppNotificationService,
                confirmDialogService: ConfirmDialogService,
                bcmUserSettingsFacade: BcmUserSettingsFacade,
                httpClient: HttpClient,
                bcmService: BcmService,
                protected bcmNavigationService: BcmNavigationService,
                private _bcmExportExcelApiService: BcmExportExcelApiService,
    ) {
        super(
            BcmVoucher,
            vouchersTableData,
            bcmNavigationService,
            appNotificationService,
            confirmDialogService,
            bcmUserSettingsFacade,
            httpClient,
            bcmService
        );
    }

}
